import axios from 'axios'
import {Message} from 'element-ui';
import store from '@/store'
import qs from 'qs'

const service = axios.create({
  baseURL: "https://kejian.za5.fun/api/",
  // baseURL: `${window.location.protocol}//${window.location.host}/api/`,
  timeout: 30000 // request timeout
})


service.interceptors.request.use(
    config => {
      if (Object.prototype.toString.call(config.data) != '[object FormData]') {
        config.data = qs.stringify(config.data) // 转为formdata数据格式
      }
      config.headers = {
        'api-type': 'wxapp',
        'Content-Type': 'application/x-www-form-urlencoded'
      }

      if (!config.headers['Authorization'] && localStorage.getItem('token')) {
        config.headers['Authorization'] = localStorage.getItem('token')
      }

      return config
    },
    error => {
      // do something with request error
      return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
      const res = response.data;
      if (res.code === 1) {
        return res
      } else if (res.code === 500 || res.code === '500') {
        Message({
          message: res.info,
          type: 'error',
          duration: 5 * 1000
        })
        store.dispatch('logout')
      } else {
        Message({
          message: res.info,
          type: 'error',
          duration: 5 * 1000
        })
      }
    },
    error => {
      Message({
        message: error.msg,
        type: 'error',
        duration: 5 * 1000
      })
      // return Promise.reject(error)
    }
)

export default service
